module.exports = __webpack_public_path__ + "static/media/jsgs.f623c719.mp4";